import { InjectionToken } from '@angular/core';

export const userLanguageToken: InjectionToken<string> = new InjectionToken('User language string', {
  factory: (): string => navigator.language,
  providedIn: 'root'
});
